module.exports = __webpack_public_path__ + "img/melilla.92b3175e.svg";